import * as React from 'react';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IRestartIconProps {
  fill?: string;
}
export const RestartIcon: React.FunctionComponent<IRestartIconProps> = ({ fill = '#111827', ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...rest}>
    <path
      fill={fill}
      d="M5.333 5.334l1.96 1.96A6.63 6.63 0 005.333 12 6.674 6.674 0 0012 18.667a6.674 6.674 0 006.666-6.666A6.674 6.674 0 0012 5.334v1.333a5.34 5.34 0 015.333 5.334A5.34 5.34 0 0112 17.334a5.34 5.34 0 01-5.334-5.333c0-1.471.6-2.802 1.567-3.767L10 10V5.334H5.333z"
    />
  </svg>
);

export default RestartIcon;
